// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".UserTaggingPingBodyStyles-cls1__a641a7e85fe2c67750b8{/*!*/}.UserTaggingPingBodyStyles-cls2___215be13ee9ea983deaf{color:#048c16;font-size:18px;margin-right:8px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "UserTaggingPingBodyStyles-cls1__a641a7e85fe2c67750b8",
	"cls2": "UserTaggingPingBodyStyles-cls2___215be13ee9ea983deaf UserTaggingPingBodyStyles-cls1__a641a7e85fe2c67750b8"
};
export default ___CSS_LOADER_EXPORT___;
